import http from "@/http/aisea/axios";

const resource = "/vessel";

const VESSEL_SEARCH_LIMIT = 20;

/**
 * 入力の空白区切りをカンマ区切りの items に正規化（連続空白は1つにまとめる）
 * @param {string} raw
 * @returns {string}
 */
function normalizeItemsFromQuery(raw) {
  if (raw == null) return "";
  const s = String(raw).trim();
  if (!s) return "";
  return s.split(/\s+/).filter(t => t !== "").join(",");
}

/**
 * /vessel/search/vessels 用。items は空白区切り→カンマ、limit は常に 20。start は送らない。
 * @param {string|{ items?: string }} payload 検索文字列、または { items }（items は生文字列でも可）
 */
function resolveItemsParam(payload) {
  if (payload == null || payload === "") {
    return "";
  }
  if (typeof payload === "string") {
    return normalizeItemsFromQuery(payload);
  }
  if (typeof payload === "object" && payload.items != null) {
    return normalizeItemsFromQuery(String(payload.items));
  }
  return "";
}

export default {

  getVessel(id) {
    return http.get(`${resource}/${id}`);
  },

  search(payload) {
    const items = resolveItemsParam(payload);

    if (!items) {
      return Promise.resolve({
        data: { vessels: [], count: 0 },
        status: 200,
      });
    }

    return http.get(`${resource}/search/vessels`, {
      params: {
        items,
        limit: VESSEL_SEARCH_LIMIT,
      },
    });
  },

};
